

import React , {useState} from 'react';
import { useTranslation } from 'react-i18next';
import setPropertyVh from '../../utils/setPropertyVh';
import StepRequirement from 'components/StepRequirement/StepRequirement';
import Xbutton from 'components/Xbutton';
import ButtonCircle from 'components/ButtonCircle/ButtonCircle';


const Onboarding_Materials = ({
    onExit,
    onBack,
    exitButtonType = 'x',
    isFirstStep = true,
    stepRequirements,
    onContinue,
}) => {
    const {t} = useTranslation();
    setPropertyVh();

    console.log("stepRequirements", stepRequirements)
    return (
        <>
        <div className={"Onboarding-container"}>
            <div className={"Onboarding-header"}>
                <div className={"Onboarding-header__side"}>
                    {exitButtonType === 'exit' && <ButtonCircle classes="ButtonCircle-exit ButtonCircle-50px" onClick={onExit} />}
                </div>
                <div className={"Onboarding-header__center"}>{t("onboarding.whatNeedForLesson")}</div>
                <div className={"Onboarding-header__side Onboarding-header__side--end"}>
                    {exitButtonType === 'x' && <Xbutton sizeM onClose={onExit} />}
                    {exitButtonType === 'exit' && !isFirstStep && <ButtonCircle classes="ButtonCircle-back ButtonCircle-50px" onClick={onBack} />}
                </div>
            </div>
            <div className={"Onboarding-content hideScrollbar"}>
                    <div className={"Onboarding-title"}>{t("onboarding.Onboarding_Materials.title")}</div>
                    <div className={"Onboarding-description"}>{t("onboarding.Onboarding_Materials.subtitle")}</div>
                    <div className="content-ab max-width-900">
                        
                    {stepRequirements.map((Requirement, index) => {
                        if (Requirement.name !== "activityPage") {
                            return (
                            <div className="req-container" key={index}>
                                <StepRequirement
                                key={index}
                                type={Requirement.name}
                                sizeM
                                showDescription
                                whiteText
                                hideBackground
                                />
                            </div>
                            );
                        }
                        return null;
                        })}
                    </div>
                    <div className='Room'></div>
            </div>
            <div className={"Onboarding-footer"}>
                {/* <button onClick={onContinue} className={"button Onboarding-button Onboarding-button-primary catbearsCTA-secondary"}>
                {t("onboarding.Onboarding_Materials.cta2")}
                </button> */}
                <button onClick={onContinue} className={"button Onboarding-button buttonCatbears buttonCatbears_CTA arcadeBtn"}>
                    {t("onboarding.Onboarding_Materials.cta")}
                </button>          
            </div>
            </div>
        </>
        )

}

export default Onboarding_Materials